const routes = {
    HEALTH: '/health',
    PROFILE: '/profile',
    BENEFITS: '/benefits',
}

export default routes